import { useCallback, useEffect, useState } from 'react';
import {
  PowerBiReportDto,
  useGetOrganizationPowerBiReports,
  useGetSingleOrganizationPowerBiReport,
} from '@sib/api';
import { useAuthStore, useUserSetupStore } from '@sib/auth';

export const usePowerBiReports = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [powerBiReports, setPowerBiReports] = useState<PowerBiReportDto[]>([]);
  const { isAuthenticated } = useAuthStore();
  const organizationId = useUserSetupStore(state => state.organization.id);

  const { data } = useGetOrganizationPowerBiReports({
    organizationId: organizationId,
    options: {
      enabled: isAuthenticated,
    },
  });
  const { mutateAsync: fetchReportDetails } =
    useGetSingleOrganizationPowerBiReport();

  const fetchAllReportDetails = useCallback(async () => {
    if (!data?.items) return;

    setIsLoading(true);
    const reports = await Promise.allSettled(
      data.items.map(async report => {
        const { id } = report;

        return fetchReportDetails({ reportId: id, organizationId });
      })
    );

    const fulfilledReports = reports
      .filter(
        (report): report is PromiseFulfilledResult<PowerBiReportDto> =>
          report.status === 'fulfilled'
      )
      .map(report => report.value);

    setPowerBiReports(fulfilledReports);
    setIsLoading(false);
  }, [data?.items, fetchReportDetails, organizationId]);

  useEffect(() => {
    fetchAllReportDetails();
  }, [fetchAllReportDetails]);

  return {
    powerBiReports,
    isLoading,
  };
};
